export default "__VITE_ASSET__CDX0fePX__"